import { render, staticRenderFns } from "./shrinkable-menu.vue?vue&type=template&id=e05c175a&"
import script from "./shrinkable-menu.vue?vue&type=script&lang=js&"
export * from "./shrinkable-menu.vue?vue&type=script&lang=js&"
import style0 from "./shrinkable-menu.vue?vue&type=style&index=0&id=e05c175a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports